import { unzip } from "fflate";

export default function unzipData(data, callback) {
  return unzip(data, callback);
}